import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
/**
 * Returns the correct emulator host depending on environment:
 * - Web → localhost
 * - Android emulator → 10.0.2.2
 * - Physical Android device → LAN IP (your laptop's IP)
 */
let cachedHost: string | null = null;

const LAN_HOST = '192.168.0.45'; // laptop's LAN IP
export async function getEmulatorHost(): Promise<string> {
  if (cachedHost) return cachedHost;

  const platform = Capacitor.getPlatform();

  if (platform === 'web') {
    cachedHost = 'localhost';
  } else if (platform === 'android') {
    // Distinguish between emulator vs real device
    try {
      const info = await Device.getInfo();
      if (info.isVirtual) {
        cachedHost = '10.0.2.2'; // Android emulator
      } else {
        cachedHost = LAN_HOST; // Physical device
      }
    } catch {
      cachedHost = '10.0.2.2';
    }
  } else if (platform === 'ios') {
    cachedHost = 'localhost';
  } else {
    cachedHost = 'localhost';
  }

  console.log('[EMU] Using host:', cachedHost);
  return cachedHost;
}
